module.exports = "<app-servico-plano-form [servicoObject]=\"servicoObject\"\n                        (serviceNewEvent)=\"getServicoObject($event)\"\n                        (submitEvent)=\"onSubmit($event)\"></app-servico-plano-form>\n\n<div class=\"geo-content__row\">\n    <app-servico-plano-table [list]=\"list\"\n                             [showRemove]=\"true\"\n                             (removeEvent)=\"clickRemove($event)\"></app-servico-plano-table>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/manutencoes/servicos/servico-planos/servico-plano-form-list/servico-plano-form-list.component.html
 ** module id = 992
 ** module chunks = 0
 **/